"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetExperimentsInternalResponseToJSON = exports.GetExperimentsInternalResponseFromJSONTyped = exports.GetExperimentsInternalResponseFromJSON = exports.instanceOfGetExperimentsInternalResponse = void 0;
var runtime_1 = require("../runtime");
var InternalExperiment_1 = require("./InternalExperiment");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the GetExperimentsInternalResponse interface.
 */
function instanceOfGetExperimentsInternalResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetExperimentsInternalResponse = instanceOfGetExperimentsInternalResponse;
function GetExperimentsInternalResponseFromJSON(json) {
    return GetExperimentsInternalResponseFromJSONTyped(json, false);
}
exports.GetExperimentsInternalResponseFromJSON = GetExperimentsInternalResponseFromJSON;
function GetExperimentsInternalResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'experiments': !(0, runtime_1.exists)(json, 'experiments') ? undefined : (json['experiments'].map(InternalExperiment_1.InternalExperimentFromJSON)),
    };
}
exports.GetExperimentsInternalResponseFromJSONTyped = GetExperimentsInternalResponseFromJSONTyped;
function GetExperimentsInternalResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'experiments': value.experiments === undefined ? undefined : (value.experiments.map(InternalExperiment_1.InternalExperimentToJSON)),
    };
}
exports.GetExperimentsInternalResponseToJSON = GetExperimentsInternalResponseToJSON;
